import { useAuth0 } from "@auth0/auth0-react";
import {
  Alert,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { useApi, useApiMutation } from "../hooks/useApi";
import { Contact } from "../types/contact";

interface Props { }

const ProfileData: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const { user } = useAuth0();
  const { apiUpdate } = useApiMutation();
  const { data: profile, isLoading } = useApi<Contact>("profile");
  const [name, setName] = useState<string | undefined>(profile?.results?.name);
  const [saving, setSaving] = useState<boolean>(false);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [nameError, setNameError] = useState<boolean>(false);
  const [lengthError, setLengthError] = useState<boolean>(false)
  const isErrored = nameError || lengthError ? true : false

  const { t } = useTranslation();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  return (
    <>
      {!isLoading && (
        <Stack spacing={4} padding={isSmallScreen ? 0 : 1}>

          {alertOpen && (
            <Alert severity="success" onClose={handleAlertClose}>
              {t("alerts.nameChange")}
            </Alert>
          )}

          <TextField
            required
            error={nameError || lengthError}
            helperText={nameError ? "Name is required" : lengthError ? "Name is too long, maximum length is 256 characters" : ""}
            label={t("profilePage.name")}
            defaultValue={profile?.results?.name}
            fullWidth
            onChange={
              // debounce(
              (event: React.ChangeEvent<HTMLInputElement>) => {
                const value = event.target.value;
                setName(value);
                if (value.length > 256) {
                  setLengthError(true);
                  setNameError(false);
                } else {
                  setLengthError(false);
                  setNameError(value.length === 0);
                }
              }
              // , 500)
            }
            inputProps={{
              maxLength: 257,
            }}
          />

          <TextField
            label={t("profilePage.email")}
            defaultValue={user?.email}
            fullWidth
            disabled
          />

          <Typography variant="body2">
            {t("profilePage.subtext")}
          </Typography>

          <Box>
            <Button
              disabled={saving || name === profile?.results?.name || isErrored}
              variant="contained"
              onClick={() => {
                setSaving(true);
                apiUpdate.mutate(
                  {
                    entity: "profile",
                    post: {
                      id: profile?.results?.id,
                      name: name,
                    },
                  },
                  {
                    onSettled: () => {
                      setSaving(false);
                      setAlertOpen(true);
                    }
                  }
                );
              }}
            >
              {saving ? t("buttons.saving") : t("buttons.save")}
            </Button>
          </Box>

        </Stack>
      )}
    </>
  );
};

export default ProfileData;
